import React from 'react';
import { AccountInfoAccordion } from '../account-info-accordion/account-info-accordion';
import AssociatedKeysTable from '../associated-keys-table/associated-keys-table';
import { AssociatedKey } from '@block-explorer/entities';

interface DetailsAccordionAssociatedKeysProps {
  accordionTitle: React.ReactElement;
  loading: boolean;
  associatedKeys: AssociatedKey[];
  actionThresholds:
    | {
        deployment: number;
        key_management: number;
      }
    | undefined;
}

export const DetailsAccordionAssociatedKeys = ({
  accordionTitle,
  ...props
}: DetailsAccordionAssociatedKeysProps) => {
  return (
    <AccountInfoAccordion
      disableClickAway
      renderContent={() => <AssociatedKeysTable {...props} />}
    >
      {accordionTitle}
    </AccountInfoAccordion>
  );
};
